import { inject, Injectable } from '@angular/core';
import { AppStateCacheService } from '@lentau/core/app-state-cache/shared/app-state-cache.service';
import { isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { UserProfile } from 'angular-api-gateway/v1/model/userProfile';
import { AppCacheKeys } from '@lentau/core/app-state-cache/shared/cache.constants';
import { withCacheErrorHandling } from '@lentau/core/app-state-cache/shared/cache-error.decorator';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileCacheService {
  private appStateCacheService: AppStateCacheService = inject(AppStateCacheService);
  private browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);

  public isExistCache: boolean = false;

  // Для SSR и Утконоса профиль пустой
  // Для клиента сперва проверяем кэш и если нет - берём сетим пустые как для B2C
  @withCacheErrorHandling(AppCacheKeys.UserProfile)
  public getProfileIds(): Partial<UserProfile> {
    if (this.browserApiSupportService.isSearchBot() || isUtk()) {
      return null;
    }

    const userProfile: string = this.appStateCacheService.get(AppCacheKeys.UserProfile);

    // Если кеш пустой
    if (!userProfile) {
      return null;
    }

    this.isExistCache = true;

    return JSON.parse(userProfile);
  }

  public updateCacheProfileIds(userProfile: Partial<UserProfile>): void {
    const { lastAddress, consentPreferences, segments, ...cacheProfile }: Partial<UserProfile> = userProfile;

    this.appStateCacheService.set(AppCacheKeys.UserProfile, JSON.stringify(cacheProfile));
  }

  public deleteCache(): void {
    this.appStateCacheService.delete(AppCacheKeys.UserProfile);
  }
}
